/**
 * @file     honeypot.ts
 * @readme   ./CLAUDE.md
 * @purpose  Honeypot field hook and styles for bot detection, hidden field that legitimate users never fill.
 */
'use client';

import { useRef, useCallback } from 'react';

export function useHoneypot() {
  const valueRef = useRef('');

  const setHoneypotValue = useCallback((val: string) => {
    valueRef.current = val;
  }, []);

  const isBot = useCallback(() => valueRef.current.length > 0, []);

  return { setHoneypotValue, isBot };
}

export const honeypotSx = {
  position: 'absolute' as const,
  // Keep the field at its natural position inside the form. Moving a real text
  // input thousands of pixels off-screen lets mobile autofill and password
  // managers focus it, which scrolls the app's nested scroll container away
  // from the visible form.
  width: 0,
  minWidth: 0,
  opacity: 0,
  pointerEvents: 'none' as const,
  height: 0,
  overflow: 'hidden' as const,
} as const;
